import { combineReducers } from "redux";
import assessmentReducer from "./assessmentReducer";

export default combineReducers({
  listings: assessmentReducer,
});
